import { mapState, mapActions } from 'vuex';

import AlugueisAtrasados from "../widgets/alugueisAtrasados/AlugueisAtrasados.vue";
import AlugueisDoDia from "../widgets/alugueisDoDia/AlugueisDoDia.vue"
import ContratosAluguelVencidos from "../widgets/contratosAluguelVencidos/ContratosAluguelVencidos.vue";
import UltimosImoveisVenda from "../widgets/ultimosImoveisVenda/UltimosImoveisVenda.vue";
import UltimosImoveisAluguel from "../widgets/ultimosImoveisAluguel/UltimosImoveisAluguel.vue";
import RepassesDoDia from "../widgets/repassesDoDia/RepassesDoDia.vue";
import RepassesAtrasados from "../widgets/repassesAtrasados/RepassesAtrasados.vue";
import ContasPagarDoDia from "../widgets/contasPagarDoDia/ContasPagarDoDia.vue"
import ContasPagarAtrasadas from "../widgets/contasPagarAtrasadas/ContasPagarAtrasadas.vue";
import ContasReceberDoDia from "../widgets/contasReceberDoDIa/ContasReceberDoDia.vue";
import ContasReceberAtrasadas from "../widgets/contasReceberAtrasadas/ContasReceberAtrasadas.vue";
import ContratosReajuste from "../widgets/contratosReajuste/ContratosReajuste.vue";
import ContratosRenovar from "../widgets/contratosRenovar/ContratosRenovar.vue";

import Util from '../util/funcoes.js';
import { TIPOS_IMOVEIS } from '../util/constantes';

import { latLng, icon } from 'leaflet';
import { LMap, LTileLayer, LMarker, LPopup } from 'vue2-leaflet'

const STATUS_IMOVEL = {
  'Disponível': 'DISPONIVEL',
  'Indisponível': 'INDISPONIVEL',
  'Arquivado': 'ARQUIVADO',
  'Reservado': 'RESERVADO',
  'Locado': 'LOCADO',
  'Em Desocupação': 'EM_DESOCUPACAO',
  'Vendido': 'VENDIDO',
};

export default {
  components: {
    AlugueisAtrasados,
    AlugueisDoDia,
    ContratosAluguelVencidos,
    UltimosImoveisVenda,
    UltimosImoveisAluguel,
    RepassesDoDia,
    RepassesAtrasados,
    ContasPagarDoDia,
    ContasPagarAtrasadas,
    ContratosReajuste,
    ContratosRenovar,
    ContasReceberDoDia,
    ContasReceberAtrasadas,
    LMap,
    LTileLayer,
    LMarker,
    LPopup
  },
  data() {
    var self = this;
    return {
      filtrarImoveisAlugueisStatus: false,
      operacaoDashboardImoveisIsVenda: false,
      imovelMapa: undefined,
      currentMidx: null,
      listaImoveisFiltradosStatus: [],

      // DASHBOARD DE VENDA
      graficoQuantidadeCaptacaoVenda: {
        settings: {
          yAxisName: ['Qtd'],
          labelMap: {
            quantidadeCaptado: 'Imóveis Captados',
            quantidadeVendido: 'Imóveis Vendidos',
          }
        },
        data: {
          columns: ['nomeMes', 'quantidadeCaptado', 'quantidadeVendido'],
          rows: []
        },
        events: {
          click(event) {
            // eslint-disable-next-line
            console.log(event);
          }
        },
        colors: ["#FF8686", "#87CF87"]
      },
      graficoTotalCaptacaoVenda: {
        settings: {
          yAxisName: ['Total (R$)'],
          labelMap: {
            totalCaptado: 'Total Captados',
            totalVendido: 'Total Vendidos',
          },
        },
        data: {
          columns: ['nomeMes', 'totalCaptado', 'totalVendido'],
          rows: []
        },
        colors: ["#FF8686", "#87CF87"]
      },
      sumarioTipoImovel: {
        settings: {
          radius: 65,
          offsetY: 115
        },
        data: {
          columns: ['titulo', 'quantidade'],
          rows: []
        },
        events: {
          click(event) {
            self.limparImovelPesquisa();
            self.imovelPesquisa.status = undefined;
            self.imovelPesquisa.tipoImovel.id = TIPOS_IMOVEIS.filter((tipoImovel) => { return tipoImovel.nome == event.data.name })[0].id;

            self.limparImoveisListados();
            self.$router.push("/imoveis");
          }
        },
        colors: ["#5DA5DA", "#FAA43A"]
      },
      sumarioStatus: {
        settings: {
          radius: 65,
          offsetY: 115
        },
        data: {
          columns: ['titulo', 'quantidade'],
          rows: []
        },
        events: {
          click(event) {
            self.limparImovelPesquisa();
            self.imovelPesquisa.status = STATUS_IMOVEL[event.data.name];
            
            self.limparImoveisListados();
            self.$router.push("/imoveis");
          }
        }
      },
      sumarioFotos: {
        settings: {
          radius: 65,
          offsetY: 115
        },
        data: {
          columns: ['titulo', 'quantidade'],
          rows: []
        },
        events: {
          click(event) {
            self.limparImovelPesquisa();
            self.imovelPesquisa.status = undefined;
            if(event.data.name == "Com Fotos") {
              self.imovelPesquisa.filtroDashboard = "IMOVEIS_COM_FOTO";
            } else if(event.data.name == "Sem Fotos") {
              self.imovelPesquisa.filtroDashboard = "IMOVEIS_SEM_FOTO";
            }
            self.limparImoveisListados();
            self.$router.push("/imoveis");
          }
        },
        colors: ["#5DA5DA", "#FAA43A"]
      },
      sumarioLocalizacao: {
        settings: {
          radius: 65,
          offsetY: 115
        },
        data: {
          columns: ['titulo', 'quantidade'],
          rows: []
        },
        events: {
          click(event) {
            self.limparImovelPesquisa();
            self.imovelPesquisa.status = undefined;
            if(event.data.name == "Com Localização") {
              self.imovelPesquisa.filtroDashboard = "IMOVEIS_COM_LOCALIZACAO";
            } else if(event.data.name == "Sem Localização") {
              self.imovelPesquisa.filtroDashboard = "IMOVEIS_SEM_LOCALIZACAO";
            }
            self.limparImoveisListados();
            self.$router.push("/imoveis");
          } 
        },
        colors: ["#60BD68", "#B2912F"]
      },

      // DASHBOARD DE ALUGUEL
      graficoQuantidadeCaptacaoAluguel: {
        settings: {
          yAxisName: ['Qtd'],
          labelMap: {
            quantidadeCaptado: 'Imóveis Captados',
            quantidadeAlugado: 'Imóveis Alugados'
          },
          radius: 65,
          offsetY: 115
        },
        data: {
          columns: ['nomeMes', 'quantidadeCaptado', 'quantidadeAlugado'],
          rows: []
        },
        events: {},
        colors: ["#FF8686", "#87CF87"]
      },
      graficoTotalCaptacaoAluguel: {
        settings: {
          yAxisName: ['Total (R$)'],
          labelMap: {
            totalCaptado: 'Total Captados',
            totalAlugado: 'Total Alugados'
          },
          radius: 65,
          offsetY: 115
        },
        data: {
          columns: ['nomeMes', 'totalCaptado', 'totalAlugado'],
          rows: []
        },
        colors: ["#FF8686", "#87CF87"],
      },
      sumarioInadiplentesAluguel: {
        settings: {
          radius: 65,
          offsetY: 115
        },
        data: {
          columns: ['titulo', 'quantidade'],
          rows: []
        },
        colors: ["#FAA43A","#5DA5DA"],
        events: {}
      },
      sumarioTipoImovelImoveisAluguel: {
        settings: {
          offsetY: 250,

        },
        data: {
          columns: ['titulo', 'quantidade'],
          rows: []
        },
        events: {
          click(event) {
            self.limparImovelAluguelPesquisa();
            self.imovelAluguelPesquisa.status = undefined;
            self.imovelAluguelPesquisa.tipoImovel.id = TIPOS_IMOVEIS.filter((tipoImovel) => {
              return tipoImovel.nome == event.data.name
            })[0].id;

            self.limparImoveisAluguelListados();
            self.$router.push("/alugueis/imoveis");
          }
        }
      },
      sumarioFaixasVacanciaImoveis: {
        settings: {
          radius: 24,
          offsetY: 78,
          xAxisName: ['Tempo Médio de Vacância'],
          yAxisName: ['Qtd Imóveis'],
          labelMap: {
            quantidade: 'Total de Imóveis na faixa',
          },
        },
        data: {
          columns: ['titulo', 'quantidade'],
          rows: []
        },
        events: {}
      },
      sumarioFaixasNegociacaoImoveis: {
        settings: {
          xAxisName: ['Tempo Médio de Negociação'],
          yAxisName: ['Qtd Imóveis'],
          type: 'horizontal',
          labelMap: {
            quantidade: 'Total de Imóveis na faixa',
          }
        },
        data: {
          columns: ['titulo', 'quantidade'],
          rows: []
        },
        colors: ["rgb(16, 90, 130)"],
        events: {}
      },
      sumarioStatusImoveisAluguel: {
        settings: {
          radius: 90,
          offsetY: 150
        },
        data: {
          columns: ['titulo', 'quantidade'],
          rows: []
        },
        events: {
          click(event) {
            self.limparImovelAluguelPesquisa();
            self.imovelAluguelPesquisa.status = STATUS_IMOVEL[event.data.name];
            self.limparImoveisAluguelListados();

            self.$router.push('/alugueis/imoveis');
          }
        }
      },
      sumarioAluguesAtrasados: {
        settings: {
          radius: 65,
          offsetY: 115
        },
        data: {
          columns: ['status', 'total'],
          rows: []
        },
        colors: ["#5DA5DA", "#FAA43A", "#59b1ef"]
      },
      sumarioBoletosAvulsos: {
        settings: {
          radius: 65,
          offsetY: 115
        },
        data: {
          columns: ['status', 'total'],
          rows: []
        },
        colors: ["#5DA5DA", "#FAA43A", "#59b1ef"]
      },
      sumarioBoletosAcordo: {
        settings: {
          radius: 65,
          offsetY: 115
        },
        data: {
          columns: ['status', 'total'],
          rows: []
        },
        colors: ["#5DA5DA", "#FAA43A", "#59b1ef"]
      },
      sumarioFotosImoveisAluguel: {
        settings: {
          radius: 65,
          offsetY: 115
        },
        data: {
          columns: ['titulo', 'quantidade'],
          rows: []
        },
        events: {
          click(event) {
            self.limparImovelAluguelPesquisa();
            self.imovelAluguelPesquisa.status = undefined;
            if(event.data.name == "Com Fotos") {
              self.imovelAluguelPesquisa.filtroDashboard = "IMOVEIS_COM_FOTO";
            } else if(event.data.name == "Sem Fotos") {
              self.imovelAluguelPesquisa.filtroDashboard = "IMOVEIS_SEM_FOTO";
            }
            self.limparImoveisAluguelListados();
            self.$router.push("/alugueis/imoveis");
          }
        },
        colors: ["#5DA5DA", "#FAA43A"]
      },
      sumarioLocalizacaoImoveisAluguel: {
        settings: {
          radius: 65,
          offsetY: 115
        },
        data: {
          columns: ['titulo', 'quantidade'],
          rows: []
        },
        events: {
          click(event) {
            self.limparImovelAluguelPesquisa();
            self.imovelAluguelPesquisa.status = undefined;
            if(event.data.name == "Com Localização") {
              self.imovelAluguelPesquisa.filtroDashboard = "IMOVEIS_COM_LOCALIZACAO";
            } else if(event.data.name == "Sem Localização") {
              self.imovelAluguelPesquisa.filtroDashboard = "IMOVEIS_SEM_LOCALIZACAO";
            }
            self.limparImoveisAluguelListados();
            self.$router.push('/alugueis/imoveis');
          }
        },
        colors: ["#59b1ef", "#f8a43b"]
      },
      sumarioDesempenhoLocacao: {
        settings: {
          labeMap: {
            nome: 'Usuário',
            qtdAlugueis: 'Quantidade Captado'
          }
        },

        data: {
          columns: ['nome', 'qtdAlugueis'],
          rows: []
        },
      },
      //RECEITA DE ALUGUEL MENSAL 
      sumarioReceitaAluguelMes: {
        settings: {
          yAxisName: ['Total (R$)'],
          xAxisName: ['Status'],
          radius: 65,
          offsetY: 800
         },
        options: {
          animationEnable: true,
          title: "Valores em Reais"
        }, 

        data: {
          columns: ['status', 'total'],
          rows: []
        },
      },
      
      sumarioGestaoAluguelMes: {
        settings: {

          offsetY: 200
         },
        options: {
          animationEnable: true,
          title: "Quantidade"
        }, 

        data: {
          columns: ['titulo', 'quantidade'],
          rows: []
        },
      },

      sumarioVistoriasNoMes: {
        settings: {
          radius: 65,
          offsetY: 115
        },
        data: {
          columns: ['titulo', 'quantidade'],
          rows: []
        },
        colors: ["#59b1ef", "#82d128", "#db0909"],
        events: {}
      },

      // ATENDIMENTOS
      graficoQuantidadeAtendimentos: {
        settings: {
          yAxisName: ['Qtd'],
          labelMap: {
            quantidadeAtendimentos: 'Quantidade de Atendimentos'
          }
        },
        data: {
          columns: ['nomeMes', 'quantidadeAtendimentos'],
          rows: []
        },
        colors: ["#3595BF"]
      },
      funilAtendimento: {
        columns: ['titulo', 'quantidade'],
        rows: [],
        events: {
          click() {
            self.$router.push("/atendimentos");
          }
        }
      },

      //TABS E KEYs
      tabSelecionada: "aluguel",
      tabAluguelView: "GRAFICOS",
      chartKey: 0,
      
      //LEAFLET MAPA

      urlMapa: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attributionMapa: '&copy; <a href="http:osm.org/copyright">OpenStreetMap</a> contributors',
      center: latLng(-5.0673272, -42.8014819),
      zoom: 14,
    };
  },

  async created() {
    await this.inicializarMapa();
    await this.inicializarWidgetsVenda();
    await this.inicializarWidgetsAluguel();
    await this.inicializarDashboardAtendimentos();
    //await this.inicializarDashboardImoveis();
    this.tabImoveisView = this.imobiliariaTemApenasModuloVenda ? 'imoveis_venda' : 'imoveis_aluguel';
  },
  
  computed: {
    ...mapState("vendasImoveisStore", {
      imovelPesquisa(state) { return state.imovelPesquisa }
    }),
    ...mapState("alugueisImoveisStore", {
      imovelAluguelPesquisa(state) { return state.imovelPesquisa }
    }),
    ...mapState('dashboardStore', {
      indiceSelecionado(state) { return state.indiceSelecionado},
      imoveis(state) { return state.imoveis },
    }),
    ...mapState('loginStore', {
      usuarioLogado(state) { return state.usuarioLogado },
      permissoes(state) { return state.usuarioLogado.permissoes },
      localizacaoImobiliaria(state) { return state.localizacaoImobiliaria }
    }),

    util() { return Util },

    moduloAluguel() { return this.usuarioLogado.imobiliaria.moduloAluguel },
    moduloVenda() { return this.usuarioLogado.imobiliaria.moduloVenda },

    widgets() { return this.usuarioLogado.widgets },

    imobiliariaTemModulosAluguelEVenda() {
      return this.moduloAluguel
          && this.moduloVenda;
    },

    imobiliariaTemApenasModuloVenda() {
      return !(this.moduloAluguel)
          && this.moduloVenda;
    },

    imobiliariaTemApenasModuloAluguel() {
      return this.moduloAluguel
          && !(this.moduloVenda);
    },

    exibirSwitchOperacaoDashboardImoveis() {
      return this.imobiliariaTemModulosAluguelEVenda;
    },

    exibirDashboardImoveisVenda() {
      if(this.imobiliariaTemModulosAluguelEVenda) {
        return this.operacaoDashboardImoveisIsVenda;
      }
      return this.imobiliariaTemApenasModuloVenda;
    },

    exibirDashboardImoveisAluguel() {
      if(this.imobiliariaTemModulosAluguelEVenda) {
        return !this.operacaoDashboardImoveisIsVenda;
      }
      return this.imobiliariaTemApenasModuloAluguel;
    },

    exibirWidgetImoveisCaptadosVendidosUltimoAno() {
      return this.widgets.imoveisCaptadosVendidosUltimoAno;
    },

    exibirWidgetTotalCaptadoVendidoUltimoAno() {
      return this.widgets.totalCaptadoVendidoUltimoAno;
    },

    exibirWidgetImoveisCaptadosAlugadosUltimoAno() {
      return this.widgets.imoveisCaptadosAlugadosUltimoAno;
    },

    exibirWidgetTotalCaptadoAlugadoUltimoAno() {
      return this.widgets.totalCaptadoAlugadoUltimoAno;
    },

    exibirWidgetTaxaInadiplentes(){
      return this.widgets.taxaInadiplentesAluguelMensal;
    },

    exibirWidgetReceitaAluguelMensal(){
      return this.widgets.receitaAluguelMensal;
    },
    exibirWidgetGestaoAluguelMensal(){
      return this.widgets.gestaoAluguelMensal;
    },
    exibirWidgetImoveisPorCategoria() {
      return this.widgets.imoveisPorCategoria;
    },

    exibirWidgetImoveisPorStatus() {
      return this.widgets.imoveisPorStatus;
    },

    exibirWidgetImoveisComSemFotos() {
      return this.widgets.imoveisComSemFotos;
    },

    exibirWidgetImoveisComSemLocalizacao() {
      return this.widgets.imoveisComSemLocalizacao;
    },

    exibirWidgetAlugueisAtrasados() {
      return this.widgets.alugueisAtrasados;
    },

    exibirWidgetAlugueisDoDia() {
      return this.widgets.alugueisDoDia;
    },

    exibirWidgetAlugueisVencidos() {
      return this.widgets.contratosVencidos;
    },

    exibirWidgetUltimosImoveisAluguel() {
      return this.widgets.ultimaCaptacaoAluguel;
    },

    exibirWidgetUltimosImoveisVenda() {
      return this.widgets.ultimaCaptacaoVenda;
    },

    exibirWidgetRepassesDoDia() {
      return this.widgets.repassesDoDia;
    },

    exibirWidgetRepassesAtrasados() {
      return this.widgets.repassesAtrasados;
    },
    exibirAtendimentos() {
      const permissoesAtendimentos = this.permissoes.filter(permissao => {
        return permissao.modulo == "PRETENDENTES";
      })[0]
      if(!permissoesAtendimentos) {
        return false;
      }
      return permissoesAtendimentos.visualizacao
    },

    exibirWidgetContasPagarDoDia() {
      return this.widgets.contasPagarDoDia;
    },

    exibirWidgetContasPagarAtrasadas() {
      return this.widgets.contasPagarAtrasadas
    },

    exibirWidgetContasReceberDoDia() {
      return this.widgets.contasReceberDoDia;
    },

    exibirWidgetContasReceberAtrasadas() {
      return this.widgets.contasReceberAtrasadas
    },

    exibirWidgetContratosReajuste() {
      return this.widgets.contratosReajuste
    },
    exibirWidgetsContratosRenovar() {
      return this.widgets.contratosRenovar
    },

    exibirWidgetDesempenhoLocacao() {
      return this.widgets.desempenhoLocacao
    },
    exibirWidgetVacanciaImoveis(){
      return this.widgets.vacanciaImoveis;
    },
    exibirWidgetNegociacaoImoveis(){
      return this.widgets.tempoNegociacaoImoveis;
    },
    chartSettings(){
      return this.getChartSettings();
    },
    chartSettingsBoletosAvulsos(){
      return this.getChartSettingsBoletosAvulsos();
    },
    extendsSettings(){
      return {
        legend:{
          show: false,
        },
        series: {
          barWidth: "90%",
          label: {
            show: true,
            position: "top",
            formatter: (params) => this.util.formatarValor(params.value)
          },
        },
        tooltip:{
          formatter: (params) => {
            const {name, value} = params[0]
            return `${name}: ${this.util.formatarValor(value)}`
          }
        }
      }
    },
    isDadosZerados(){
      return this.sumarioGestaoAluguelMes.data.rows.every(item => item.quantidade === 0)
    },
    centroMapa() {
      return (this.usuarioLogado.imobiliaria.latitude != null && this.usuarioLogado.imobiliaria.longitude != null) && 
      (this.usuarioLogado.imobiliaria.latitude != "" && this.usuarioLogado.imobiliaria.longitude != "") ? latLng(Number(this.usuarioLogado.imobiliaria.latitude),  Number(this.usuarioLogado.imobiliaria.longitude)) : this.center
    },
    isDadosZeradosBoletosAcordo(){
      return !this.sumarioBoletosAcordo.data.rows.every(item => item.quantidade === 0)
    },
    isDadosZeradosBoletosAvulsos(){
      return !this.sumarioBoletosAvulsos.data.rows.every(item => item.quantidade === 0)
    },
    isWidgetsZeradosGraficosAluguel(){
      return !(
        this.widgets.taxaInadiplentesAluguelMensal || 
        this.widgets.receitaAluguelMensal || 
        this.widgets.desempenhoLocacao || 
        this.widgets.gestaoAluguelMensal
      );
    },
    isWidgetsZeradosTabelasAluguel(){
      return !(
        this.widgets.alugueisAtrasados || 
        this.widgets.contratosVencidos || 
        this.widgets.ultimaCaptacaoAluguel ||
        this.widgets.repassesDoDia || 
        this.widgets.RepassesAtrasados || 
        this.widgets.alugueisDoDia ||
        this.widgets.contratosRenovar || 
        this.widgets.contratosReajuste
      )
    },
    isWidgetsZeradosImoveisAluguel(){
      return !(
        this.widgets.totalCaptadoAlugadoUltimoAno || 
        this.widgets.imoveisCaptadosAlugadosUltimoAno || 
        this.widgets.imoveisPorCategoria || 
        this.widgets.imoveisPorStatus || 
        this.widgets.imoveisComSemFotos || 
        this.widgets.imoveisComSemLocalizacao
      )
    },
    isWidgetsZeradosVenda(){
      return !(
        this.widgets.imoveisPorCategoria || 
        this.widgets.imoveisPorStatus || 
        this.widgets.imoveisComSemFotos || 
        this.widgets.imoveisComSemLocalizacao || 
        this.widgets.imoveisCaptadosVendidosUltimoAno || 
        this.widgets.totalCaptadoVendidoUltimoAno ||
        this.widgets.ultimaCaptacaoVenda
      )
    },
    isWidgetsZeradosContas(){
      return !(
        this.widgets.contasPagarAtrasadas || 
        this.widgets.contasPagarDoDia || 
        this.widgets.contasReceberAtrasadas || 
        this.widgets.contasReceberDoDia
      )
    }
  },
  watch: {
    'filtrarImoveisAlugueisStatus': function (newValue, oldValue) {
      if(newValue != oldValue) {
        if(newValue === true) {
          this.sumarioStatusImoveisAluguel.data.rows = this.sumarioStatusImoveisAluguel.data.rows.filter(item => {return item.titulo != "Excluído" && item.titulo != "Arquivado"})
           
        } else {
         this.inicializarWidgetsImovelAluguelPorStatus();
        }
      }
    },
    tabSelecionada : 'refreshCharts',
    tabAluguelView : 'refreshCharts',
    indiceSelecionado: function(newValue){
      this.refreshCharts()
      if(newValue === 'dashboardImoveis'){
        this.iniciarWidgets();
      }
    }  

  },
  methods: {
    ...mapActions([
      "showLoading",
      "hideLoading"
    ]),
    ...mapActions('dashboardStore', [
      'atualizarIndiceSelecionado',
      'recuperarImoveisMapa',
      'listarImoveisCaptadosVendidos',
      'recuperarSumarioTipoImovel',
      'recuperarSumarioStatus',
      'recuperarSumarioFotos',
      'recuperarSumarioLocalizacao',
      'listarImoveisCaptadosAlugados',
      'recuperarSumarioTipoImovelImoveisAluguel',
      'recuperarFaixasVacancia',
      'recuperarFaixasNegociacao',
      'recuperarSumarioStatusImoveisAluguel',
      'recuperarQuantidadeAlugueisAtrasadosPorStatus',
      'recuperarQuantidadeBoletosAvulsos',
      'recuperarQuantidadeBoletosAcordo',
      'recuperarSumarioLocatariosInadiplentesAluguel',
      'recuperarGestaoAluguelMesAtual',
      'recuperarSumarioReceitaAluguelMes',
      'recuperarSumarioFotosImoveisAluguel',
      'recuperarSumarioLocalizacaoImoveisAluguel',
      'listarAtendimentos',
      'recuperarSumarioAtendimento',
      'recuperarDesempenhoLocacao',
      'recuperarVistoriasNoMes'
    ]),
    ...mapActions('vendasImoveisStore', [
      'recuperarImovel',
      'listarImoveis',
      'limparImovelPesquisa',
      'limparImoveisListados'
    ]),
    ...mapActions('alugueisImoveisStore', {
      'recuperarImovelAluguel':'recuperarImovel',
      'listarImoveisAluguel':'listarImoveis',
      'limparImovelAluguelPesquisa': 'limparImovelPesquisa',
      'limparImoveisAluguelListados': 'limparImoveisListados'
    }),

    getChartSettings(){
      return {
        itemStyle: {
          color: (params) => {
            const colors = ['#5ca5da', '#41d4ae', '#f76d85']
            return colors[params.dataIndex % colors.length]
          },
        }
      }
    },
    getChartSettingsBoletosAvulsos(){
      return {
        itemStyle: {
          color: (params) => {
            const colors = ['#f76d85','#5ca5da', '#41d4ae']
            return colors[params.dataIndex % colors.length]
          },
        }
      }
    },
    //RENDERIZA OS GRAFICOS
    refreshCharts(){
      this.chartKey++;
    },
    iniciarWidgets(){
      this.tabAluguelView = this.widgets.inicioWidgets;
    },
    async inicializarMapa() {
      await this.recuperarImoveisMapa();
    },

    async inicializarWidgetsVenda() {
      await this.inicializarWidgetsCaptacaoVenda();
      await this.inicializarWidgetsImovelVendaPorTipo();
      await this.inicializarWidgetsImovelVendaPorStatus();
      await this.inicializarWidgetsImovelVendaPorFotos();
      await this.inicializarWidgetsImovelVendaPorLocalizacao();
    },

    async inicializarWidgetsAluguel() {
      await this.inicializarWidgetsCaptacaoAluguel();
      await this.inicializarWidgetsImovelAluguelPorTipo();
      await this.inicializarDashboardVacancias();
      await this.inicializarDashboardNegociacoes();
      await this.inicializarWidgetsImovelAluguelPorStatus();
      await this.inicializarWidgetQuantidadeAlugueisAtrasados();
      await this.inicializarWidgetQuantidadeBoletosAvulsos();
      await this.inicializarWidgetQuantidadeBoletosAcordo();
      await this.inicializarWidgetsImovelAluguelPorFotos();
      await this.inicializarWidgetsImovelAluguelPorLocalizacao();
      await this.inicializarWidgetsImovelDesempenhoLocacao();
      await this.inicializarWidgetsAluguelInadiplentes();
      await this.inicializarWidgetsReceitaAluguelMes();
      await this.inicializarWidgetsGestaoAluguelMesAtual();
      await this.inicializarGraficoVistoriasNoMes();
    },

    async inicializarDashboardAtendimentos() {
      await this.inicializarGraficoAtendimentos();
      await this.inicializarFunilAtendimentos();
    },

    async inicializarWidgetsCaptacaoVenda() {
      const resultado = await this.listarImoveisCaptadosVendidos();
      this.graficoQuantidadeCaptacaoVenda.data.rows = resultado.lista;
      this.graficoTotalCaptacaoVenda.data.rows = resultado.lista;
    },

    async inicializarWidgetsImovelVendaPorTipo() {
      const resultado = await this.recuperarSumarioTipoImovel();
      this.sumarioTipoImovel.data.rows = resultado.lista;
    },

    async inicializarWidgetsImovelVendaPorStatus() {
      const resultado = await this.recuperarSumarioStatus();
      this.sumarioStatus.data.rows = resultado.lista;
    },

    async inicializarWidgetsImovelVendaPorFotos() {
      const resultado = await this.recuperarSumarioFotos();
      this.sumarioFotos.data.rows = resultado.lista;
    },

    async inicializarWidgetsImovelVendaPorLocalizacao() {
      const resultado = await this.recuperarSumarioLocalizacao();
      this.sumarioLocalizacao.data.rows = resultado.lista;
    },

    async inicializarWidgetsCaptacaoAluguel() {
      const resultado = await this.listarImoveisCaptadosAlugados();
      this.graficoQuantidadeCaptacaoAluguel.data.rows = resultado.lista;
      this.graficoTotalCaptacaoAluguel.data.rows = resultado.lista;
    },

    async inicializarWidgetsImovelAluguelPorTipo() {
      const resultado = await this.recuperarSumarioTipoImovelImoveisAluguel();
      this.sumarioTipoImovelImoveisAluguel.data.rows = resultado.lista;
    },

    async inicializarDashboardVacancias(){
      const resultado = await this.recuperarFaixasVacancia();
      this.sumarioFaixasVacanciaImoveis.data.rows = resultado.lista;
    },

    async inicializarDashboardNegociacoes(){
      const resultado = await this.recuperarFaixasNegociacao();
      this.sumarioFaixasNegociacaoImoveis.data.rows = resultado.lista;
    },

    async inicializarWidgetsImovelAluguelPorStatus() {
      const resultado = await this.recuperarSumarioStatusImoveisAluguel();
      this.sumarioStatusImoveisAluguel.data.rows = resultado.lista;
    },

    async inicializarWidgetQuantidadeAlugueisAtrasados() {
      const resultado = await this.recuperarQuantidadeAlugueisAtrasadosPorStatus();
      this.sumarioAluguesAtrasados.data.rows = resultado.lista;
    },

    async inicializarWidgetQuantidadeBoletosAvulsos() {
      const resultado = await this.recuperarQuantidadeBoletosAvulsos();
      this.sumarioBoletosAvulsos.data.rows = resultado.lista;
    },

    async inicializarWidgetQuantidadeBoletosAcordo() {
      const resultado = await this.recuperarQuantidadeBoletosAcordo();
      this.sumarioBoletosAcordo.data.rows = resultado.lista;
    },

    async inicializarWidgetsAluguelInadiplentes(){
      const resultado = await this.recuperarSumarioLocatariosInadiplentesAluguel();     
      this.sumarioInadiplentesAluguel.data.rows = resultado.lista;      
    },

    async inicializarWidgetsGestaoAluguelMesAtual(){
      const resultado = await this.recuperarGestaoAluguelMesAtual();     
      this.sumarioGestaoAluguelMes.data.rows = resultado.lista;      
    },

    async inicializarWidgetsReceitaAluguelMes(){
      const resultado = await this.recuperarSumarioReceitaAluguelMes();
      this.sumarioReceitaAluguelMes.data.rows = resultado.lista;
    },

    async inicializarWidgetsImovelAluguelPorFotos() {
      const resultado = await this.recuperarSumarioFotosImoveisAluguel();
      this.sumarioFotosImoveisAluguel.data.rows = resultado.lista;
    },

    async inicializarWidgetsImovelAluguelPorLocalizacao() {
      const resultado = await this.recuperarSumarioLocalizacaoImoveisAluguel();
      this.sumarioLocalizacaoImoveisAluguel.data.rows = resultado.lista;
    },
    
    async inicializarWidgetsImovelDesempenhoLocacao() {
      const resultado = await this.recuperarDesempenhoLocacao();
      this.sumarioDesempenhoLocacao.data.rows = resultado.lista;
    },

    async inicializarGraficoVistoriasNoMes() {
      const resultado = await this.recuperarVistoriasNoMes();
      this.sumarioVistoriasNoMes.data.rows = resultado.lista;
    },

    async inicializarGraficoAtendimentos() {
      const resultado = await this.listarAtendimentos();
      this.graficoQuantidadeAtendimentos.data.rows = resultado.lista;
    },

    async inicializarFunilAtendimentos() {
      const resultado = await this.recuperarSumarioAtendimento();
      this.funilAtendimento.rows = resultado.lista;
    },
    
    handleSelect(key) {
      this.atualizarIndiceSelecionado(key);
    },

    visualizarImovel(imovel){
      if(imovel.operacao === 'VENDA'){
        this.limparImovelPesquisa();
        this.imovelPesquisa.id = imovel.id;
        this.imovelPesquisa.idNaImobiliaria = imovel.idNaImobiliaria;
        this.limparImoveisListados();
        this.recuperarImovel(this.imovelPesquisa);

        this.$router.push("/imoveis");
      } else {
        this.limparImovelAluguelPesquisa();
        this.imovelAluguelPesquisa.id = imovel.id;
        this.imovelAluguelPesquisa.idNaImobiliaria = imovel.idNaImobiliaria;
        this.limparImoveisAluguelListados();
        this.recuperarImovelAluguel(this.imovelPesquisa);

        this.$router.push("/alugueis/imoveis");
      }
    },

    getLatLngImovel(lat, lgn) {
      return latLng(lat, lgn)
    },

    customIconMap(imovel) {
      if(imovel.categoria == 'LANCAMENTO'){
        return icon({ 
          iconUrl: require("./icons/mapIconGreen.png"),
          iconSize: [32, 37],
          iconAnchor: [16, 37]
        });
      } else if (this.util.stringParaData(imovel.dataCaptacao) > this.util.adicionarDiasData(-14)) {
        return icon({
          iconUrl: require("./icons/mapIconBlue.png"),
          iconSize: [32, 37],
          iconAnchor: [16, 37]
        });
      }

      return icon({
        iconUrl: require("./icons/mapIconRed.png"),
        iconSize: [32, 37],
        iconAnchor: [16, 37]
      });
    }
  }

}